import { useMemo, useEffect, useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

function TopRuler() {
  const ticks = useMemo(() => Array.from({ length: 31 }, (_, i) => i * 5), []);
  const rulerRef = useRef(null);
  const x = useMotionValue(0);
  const smoothX = useSpring(x, { damping: 25, stiffness: 400 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (rulerRef.current) {
        const rect = rulerRef.current.getBoundingClientRect();
        const relativeX = e.clientX - rect.left;
        const pixels = Math.max(0, Math.min(510, relativeX));
        x.set(pixels);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [x]);

  return (
    <div ref={rulerRef} className="relative w-[535px] pointer-events-none select-none">
      {/* Cursor-following Triangle marker */}
      <motion.div
        className="absolute -top-6 w-0 h-0 border-l-[10px] -ml-[10px] border-r-[10px] border-t-[10px] border-transparent border-t-white"
        style={{
          left: smoothX,
          transformTemplate: ({ left }) => `translateX(calc(${left}px - 50%))`
        }}
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3, delay: 2.2, ease: "easeOut" }}
      />
      <div className="inset-0 flex items-start gap-2 justify-center">
        <div className="relative flex items-start gap-4 justify-center -ml-6">
          {/* Main border line */}
          <svg className="absolute top-0 left-0 w-full h-px">
            <motion.line
              x1="0"
              y1="0"
              x2="100%"
              y2="0"
              stroke="white"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 1.0, delay: 1.0, ease: "easeInOut" }}
            />
          </svg>
          {ticks.map((n, i) => (
            <div key={i} className="relative">
              <motion.div 
                className={`${i % 5 === 0 ? "h-4 w-px bg-white" : "h-2 w-px bg-white"}`}
                initial={{ scaleY: 0, opacity: 0 }}
                animate={{ scaleY: 1, opacity: 1 }}
                transition={{ 
                  duration: 0.2, 
                  delay: 2.0 + i * 0.02, 
                  ease: "easeOut" 
                }}
                style={{ transformOrigin: "top" }}
              />
              {i % 5 === 0 && (
                <motion.div 
                  className="absolute -bottom-6 -ml-3 w-6 text-center text-white"
                  initial={{ opacity: 0, y: -5 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ 
                    duration: 0.3, 
                    delay: 2.0 + i * 0.02 + 0.1, 
                    ease: "easeOut" 
                  }}
                >
                  {n}
                </motion.div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TopRuler;